import { defineMessages } from '../../i18n/messages';

export const StatusMessages = defineMessages({
  PAGE_TITLE: {
    id: 'status.page_title',
    text: 'System Status',
    description: 'Page header on the system status page',
  },
  PAGE_SUBTITLE: {
    id: 'status.page_subtitle_v2',
    text: 'How to find out whether something is wrong, and how to tell us.',
    description: 'Subtitle below the page header. Replaces "Current operational status of Localingos services", which promised live status information this page does not have.',
  },
  /*
   * There is no health check behind this page. It used to assert "All Systems
   * Operational" and "No recent incidents" as facts, on a page a developer visits
   * precisely because they suspect otherwise — and a developer who works out that
   * the green ticks are hardcoded strings has good reason to distrust everything
   * else on the site. New ids rather than edited text, so the old translations
   * cannot keep making the claim in 56 languages.
   */
  NOT_AUTOMATED: {
    id: 'status.not_automated_v2',
    text: 'We do not publish an automated status feed yet',
    description: 'Heading stating honestly that this page is not backed by automated monitoring. Replaces a hardcoded claim that all systems were operational.',
  },
  NOT_AUTOMATED_BODY: {
    id: 'status.not_automated_body_v2',
    text: 'This page is not wired to a health check, so it cannot tell you whether something is broken right now. If you are seeing a problem, email us and we will tell you what we know — usually within a few hours.',
    description: 'Explanation under the heading, stating that the page has no live monitoring behind it and directing the reader to email support instead.',
  },
  SERVICES_HEADING: {
    id: 'status.services_heading_v2',
    text: 'What runs the service',
    description: 'Section heading above the list of the platform components that make up the service. Reworded from "Services" because the list no longer claims a status for each one.',
  },
  REST_API: {
    id: 'status.rest_api',
    text: 'REST API',
    description: 'Status line item for the REST API service',
  },
  TRANSLATION_PIPELINE: {
    id: 'status.translation_pipeline',
    text: 'Translation pipeline',
    description: 'Status line item for the translation pipeline service',
  },
  WEB_DASHBOARD: {
    id: 'status.web_dashboard',
    text: 'Web dashboard',
    description: 'Status line item for the web dashboard service',
  },
  AUTHENTICATION: {
    id: 'status.authentication',
    text: 'Authentication (Amazon Cognito)',
    description: 'Status line item for the Cognito authentication service',
  },
  BILLING: {
    id: 'status.billing',
    text: 'Billing (Stripe)',
    description: 'Status line item for the Stripe billing service',
  },
  INCIDENTS_HEADING: {
    id: 'status.incidents_heading',
    text: 'Incidents',
    description: 'Section heading above the incidents section',
  },
  NO_INCIDENTS: {
    id: 'status.no_incidents_v2',
    text: 'We do not keep a public incident log yet. Ask us and we will tell you straight.',
    description: 'Text replacing a hardcoded claim that there had been no recent incidents. States that no public incident history is published and invites the reader to ask.',
  },
  REPORT_HEADING: {
    id: 'status.report_heading',
    text: 'Report an Issue',
    description: 'Section heading for the issue reporting area at the bottom of the status page',
  },
  REPORT_TEXT: {
    id: 'status.report_text',
    text: "If you're experiencing problems, please contact <1>support@localingos.com</1>.",
    description: 'Instruction text with a mailto link for reporting issues. <1> wraps the support email address',
  },
  BREADCRUMB: {
    id: 'status.breadcrumb',
    text: 'Status',
    description:
      'Name of this page in the schema.org BreadcrumbList structured data, following the "Home" crumb. Keep it short — it is a navigation trail label, not the page heading "System Status".',
  },
});
